/**
 * The "Your Sked" app-window chrome around the team mirror (SKE-4166, demo UX
 * uplift).
 *
 * Pairs with ClientFrame: where the client's side wears a neutral browser
 * window, the team's side wears a compact Sked app frame — a slim blurple title
 * bar with the Sked app-block mark — so the two panes read as two different
 * screens (your client's browser vs. your Sked app) rather than one wide page.
 *
 * The MarketerMirror inside keeps its own in-app header (workspace name); this
 * is only the outer window chrome, the same way ClientFrame's browser bar sits
 * above the approver's own Navbar.
 *
 * STATIC ONLY — border / shadow / background / padding, never transform (same
 * containing-block rule as ClientFrame / demoReveal.ts). Tailwind + Font
 * Awesome only.
 */

import { demoStrings } from './demoStrings'

const TeamChrome: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-xl border border-blue-100 bg-white shadow-[0_12px_40px_-12px_rgba(16,24,40,0.25)]">
    {/* Persistent side identity: a blurple hairline marks this as your own
        workspace — the counterpart to ClientFrame's warm (spice) hairline. */}
    <div aria-hidden="true" className="h-[3px] shrink-0 bg-blue-500" />

    {/* App title bar — the Sked app-block mark on a lavender ground, kept light
        so it doesn't stack a second heavy bar on the mirror's blue header. */}
    <div className="flex shrink-0 items-center gap-2 border-b border-blue-100 bg-blue-50 px-3 py-2">
      <span
        aria-hidden="true"
        className="flex h-5 w-5 items-center justify-center rounded-md bg-blue-500 font-gotham text-[11px] font-extrabold text-white"
      >
        S
      </span>
      <span className="font-gotham text-sm font-bold tracking-tight text-blue-800">
        {demoStrings.sideTeamLabel}
      </span>
    </div>

    <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
  </div>
)

export default TeamChrome
